module.exports = __webpack_public_path__ + "static/img_2423-31d2f2dbad75bd99118c6c4a9ba9befb.webp";